// src/mocks/mockApi.js
import { mockDb } from "./mockDb";

const sleep = (ms) => new Promise((r) => setTimeout(r, ms));

export const mockApi = {
  async adminList(params) {
    await sleep(150);
    return mockDb.listAdmin(params);
  },
  async adminDetail(id) {
    await sleep(120);
    return mockDb.getById(id);
  },
  async mySlip(params) {
    await sleep(120);
    return mockDb.getMy(params);
  },
  async sign(payload) {
    await sleep(120);
    return mockDb.sign(payload);
  },
  async verify(payload) {
    await sleep(120);
    return mockDb.verify(payload);
  },
  async reject(payload) {
    await sleep(120);
    return mockDb.reject(payload);
  },
};
